module.exports = __webpack_public_path__ + "img/Rack and pinion.e7cb4f56.jpg";